import { Component, OnInit } from '@angular/core';

function aproposdefn() {
  alert("Bonjour !! \n\n Ceci est un mini-projet ISTIC pour le niveau LGLSI-2 en 2021 \n Réalisé par: Mohamed Dhia Jebali - Mariem Benjaballah - Aymen Tayari \n\n C'est une application web faite par angular pour la gestion des employés \n Vous pouvez ajouter, modifier, supprimer, chercher et consulter chaque employé dans la base de données de l'application");
}

function hoversoundfn() {
  var audio = new Audio('../assets/aud/cursor.ogg');
audio.play();
}

function clicksoundfn() {
  var audio = new Audio('../assets/aud/select.ogg');
audio.play();
}

async function deconnecter_fn() {
  var audio = new Audio('../assets/aud/exit.ogg');
  audio.play();
        localStorage.removeItem("connecteid");
        localStorage.removeItem("connectmdp");
        localStorage.removeItem("connectnom");
        window.location.href = '/connecter' ;

} ;


async function backend_tester_fn() {
  var eid = localStorage.getItem("connecteid");
  var motdepasse = localStorage.getItem("connectmdp");
  const rep = await fetch(`http://127.0.0.1:8000/gestionemployes/backend_connecter_bd?eid=${eid}&motdepasse=${motdepasse}`) ;   
  if (rep.ok){
    rep.json().then((data)=>{ 
      if (data.length != 0) {
        if (data[0].admin == 1) {
          window.location.href = '/accueiladmin' ;
        }
        if (data[0].admin == 0) {
          (document.getElementById("connectnomm") as HTMLFormElement).insertAdjacentHTML("afterbegin",data[0].nom+" ") ;
        }
      }
      else {
        localStorage.removeItem("connecteid");
        localStorage.removeItem("connectmdp");
        localStorage.removeItem("connectnom");
        window.location.href = '/connecter' ;
      }
    }) 
  } else {
    localStorage.removeItem("connecteid");
    localStorage.removeItem("connectmdp");
    localStorage.removeItem("connectnom");
    window.location.href = '/connecter' ;
  }
} ;



@Component({
  selector: 'app-accueilemploye',
  templateUrl: './accueilemploye.component.html',
  styleUrls: ['./accueilemploye.component.css']
})
export class AccueilemployeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    backend_tester_fn()
  }

  aproposderun() {
    aproposdefn();
  }

  deconnecter() {
    deconnecter_fn() 
  }

  hoversound() {
    hoversoundfn();
  }

  clicksound() {
    clicksoundfn();
  }


}
